import GlobalContext from '../bootstrap';
import initResumeUploadForm from '../resume/upload';

class JobDetailPage extends GlobalContext {
    constructor() {
        super();
        this._initialiseComponents();
    }

    _initialiseComponents(): void {
        initResumeUploadForm();
    }
}

if ( !window.jobDetailsPage ) {
    window.jobDetailsPage = new JobDetailPage();
}
